import { useTranslation } from "react-i18next";

const BAND = {
  excellent: "text-success", good: "text-primary", fair: "text-warning", weak: "text-destructive",
};

// صف أداء موظف واحد: الدرجة النهائية ومركّباتها وخصم العقوبات.
export const KpiRow = ({ row, rank, onOpen }) => {
  const { t } = useTranslation();
  return (
    <tr className="cursor-pointer border-b border-border/40 hover:bg-primary/5"
        data-testid={`kpi-row-${row.user_id}`} onClick={() => onOpen(row)}>
      <td className="p-2 num text-xs text-muted-foreground">{rank}</td>
      <td className="p-2 text-xs font-bold">{row.employee_name}</td>
      <td className="p-2 text-xs text-muted-foreground">{row.branch_name || "—"}</td>
      <td className="p-2 num font-mono text-xs">{row.present_days}/{row.workdays}</td>
      <td className="p-2 num font-mono text-xs">{row.late_days}</td>
      <td className="p-2 num font-mono text-xs">{row.absent_days}</td>
      <td className="p-2 num font-mono text-xs">{row.duties_done}/{row.duties_assigned}</td>
      <td className="p-2 num font-mono text-xs">{row.tasks_done}/{row.tasks_assigned}</td>
      <td className="p-2 num font-mono text-xs text-destructive">
        {row.penalty_deduction ? `-${row.penalty_deduction}` : "—"}
      </td>
      <td className={`p-2 num font-mono text-sm font-black ${BAND[row.band]}`}>{row.score}</td>
      <td className={`p-2 text-[11px] font-bold ${BAND[row.band]}`}>{t(`kpi.band.${row.band}`)}</td>
    </tr>
  );
};
